import React from 'react'

const LazyComponent = React.lazy(async () => import('./tracking'))

export const LazyTrackingHead: React.FC = () => {
  const isSSR = typeof window === 'undefined'
  return (
    <>
      {!isSSR && (
        <React.Suspense fallback={null}>
          <LazyComponent />
        </React.Suspense>
      )}
    </>
  )
}
